import styled, { css } from 'styled-components';

import WhatsOnPartnerLogos from './WhatsOn/WhatsOnPartnerLogos';
import WhatsOnImageSlider from './WhatsOn/WhatsOnImageSlider';
import ImageSliderSubSection from './WhatsOn/ImageSliderSubSection';
import WhatsOnLeaderboard from './WhatsOn/WhatsOnLeaderboard';
import WhatsOnPrizes from './WhatsOn/WhatsOnPrizes';
import WhatsOn from './LandingPage/WhatsOn';
import WhatsOnForm from './WhatsOn/WhatsOnForm';
import WhatsOnTerms from './WhatsOn/WhatsOnTerms';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';

const Header = styled.div`
  position: relative;
  height: 40vh;
  overflow: hidden;
  z-index: 10;

  ${BREAKPOINTS.small`
    height: 100vh;
  `}
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const RepeatingBg = styled.div`
  background-color: ${COLORS.shootoutBlue};

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background: url(${backgroundImage}) repeat -100px -50px;
      background-size: 100%;

      ${BREAKPOINTS.small`
        background-size: 70%;
      `};

      ${BREAKPOINTS.xLarge`
        background-size: 45%;
      `};
    `};
`;

const Section = styled.section`
  position: relative;
  min-height: 560px;
  color: ${COLORS.shootoutLightBlue};

  ${BREAKPOINTS.small`
    min-height: 831px;
  `}

  ${BREAKPOINTS.medium`
    min-height: 878px;
  `}

  ${BREAKPOINTS.large`
    min-height: 976px;
  `}
`;

const CircleMask = styled.div`
  background-color: ${COLORS.forest};
  border-radius: 50vw 50vw 0 0;
  overflow: hidden;

  /* Fix for overflow hidden with border-radius in Safari */
  transform: translateZ(0) translateY(1px);
`;

const MutedPinkBackground = styled.div`
  background-color: ${COLORS.pinkMuted};
`;

const WhatsOnPage = ({
  whatsOn,
  page: {
    videoHeader,
    whatsOnPartnerLogos,
    backgroundImage,
    imageSliderHeading01,
    imageSliderHeading02,
    imageSliderCopy,
    imageSlider,
    imageSliderSubHeading,
    imageSliderSubCopy,
    leaderboard,
    hotShotPrizes,
    whatsOnForm,
    sourceId,
  },
}) => {
  const hasImageSlider =
    imageSliderHeading01 &&
    imageSliderHeading02 &&
    imageSliderCopy &&
    imageSlider;

  return (
    <>
      {videoHeader && (
        <Header>
          <BackgroundVideo muted playsInline autoPlay loop>
            <source src={videoHeader.video?.url} type="video/mp4" />
          </BackgroundVideo>
        </Header>
      )}

      <RepeatingBg backgroundImage={backgroundImage?.url}>
        {whatsOnPartnerLogos && (
          <WhatsOnPartnerLogos data={whatsOnPartnerLogos} />
        )}

        {hasImageSlider && (
          <Section>
            <CircleMask>
              <WhatsOnImageSlider
                headingFirst={imageSliderHeading01}
                headingSecond={imageSliderHeading02}
                headingCopy={imageSliderCopy}
                imageSlider={imageSlider}
              />

              <ImageSliderSubSection
                subHeading={imageSliderSubHeading}
                subCopy={imageSliderSubCopy}
                showRegisterCta={whatsOnForm} // Only show register button if the whatsOnForm is enabled.
              />
            </CircleMask>
          </Section>
        )}
      </RepeatingBg>

      {leaderboard && (
        <WhatsOnLeaderboard
          sectionHeading={leaderboard.sectionHeading}
          leaderboardHeading={leaderboard.leaderboardHeading}
          leaderboardPlayers={leaderboard.player}
          buttonLabel={leaderboard.buttonLabel}
          claysLogo={leaderboard.claysLogo}
          partnerLogo={leaderboard.partnerLogo}
          backgroundImage={backgroundImage?.url}
        />
      )}

      {hotShotPrizes && (
        <WhatsOnPrizes
          sectionHeading={hotShotPrizes.sectionHeading}
          prizeData={hotShotPrizes.prize}
        />
      )}

      <MutedPinkBackground>
        {whatsOnForm && (
          <>
            <WhatsOnForm data={whatsOnForm} sourceId={sourceId} />

            <WhatsOnTerms
              heading={whatsOnForm.termsHeading}
              description={whatsOnForm.termsDescription}
            />
          </>
        )}

        <WhatsOn
          description={whatsOn.groupsDescription}
          images={whatsOn.imageSlider}
          bgColorNone
        />
      </MutedPinkBackground>
    </>
  );
};

export default WhatsOnPage;
